export default "__VITE_ASSET__C7_B4G8F__"